import { useMobile } from 'common-nextjs';
import React from 'react';
import ListFlowBaseDescription from '~/components/ListFlow/Descriptions/ListFlowBaseDescription';
import SuggestedAngles from '~/components/ListFlow/PhotoSection/SuggestedAngles';

interface Props {}

const ListFlowPhotoDescription: React.FC<Props> = () => {
  const mobile = useMobile();
  return (
    <ListFlowBaseDescription
      title="Better photos = More sales"
      bulletItems={[
        <span key={1}>
          Take photos in natural light and remove any clutter from the
          background
        </span>,
      ]}
      postContent={
        mobile ? (
          <div>
            <div className="mb-2 font-bold italic">Suggested angles</div>
            <SuggestedAngles />
          </div>
        ) : undefined
      }
    />
  );
};

export default ListFlowPhotoDescription;
